var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":"","pa-0":"","text-xs-center":""}},[_c('v-layout',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"1200px","height":"900px","src":"https://datastudio.google.com/embed/reporting/1TfDQCmrFVTOZXfCe5h78CRc25vMzOuBJ/page/zyL0","frameborder":"0","allowfullscreen":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e01bdb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charger/ChargerReport.vue
// module id = null
// module chunks = 